<template>
<div class="flex">
  <img v-if="movie && movie.length !=0" :src="movie.response.logo" alt="" width="200px" height="100">
  <vs-upload v-if="movie && movie.response" :action="`${this.$apiUrl}/movies/poster/${movie.response.id}`" fileName="logo"  limit="1" text="Logo Image" vs-tab="dfdf" :automatic="true" @on-success="successUpload" />
</div>
</template>
<script>
export default {
    props:['movie'],
  methods:{
    successUpload(){
      this.$vs.notify({color:'success',title:'Upload Success',text:''})
      setTimeout(() => {
        location.reload();  
      }, 1000);
      
    }
  }
}
</script>